<template>
  <div>
    <div class="bg mb10">
      <div class="flex flex-end mb10">
        <el-select
          size="small"
          v-model="searchCondition.storeCode"
          style="width:260px"
          filterable
          @change="queryAll"
        >
          <el-option
            v-for="(item, index) in seleteAppList"
            :key="index"
            :label="item.nickName"
            :value="item.storeCode"
          ></el-option>
        </el-select>
      </div>

      <div class="flex flex-between item-center">
        <div class="title">
          统计概览
        </div>
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="daterange"
          align="right"
          start-placeholder="请选择时间段"
          end-placeholder="请选择时间段"
          value-format="yyyy-MM-dd"
          size="small"
          :editable="false"
          :clearable="false"
          :picker-options="pickerOptions"
          @change="queryAll"
        ></el-date-picker>
      </div>
      <div class="flex flex-between" style="margin-top:50px">
        <div
          v-for="(v, i) in tabList"
          :key="i"
          class="box flex-1"
          :class="{ 'bor-left': i !== 0 }"
        >
          <div class="name flex item-center flex-center">
            {{ v.title }}
            <!-- <i
              class="el-icon-question"
              style="font-size: 18px;color:#ddd;margin-left:5px"
            ></i> -->
          </div>
          <div class="text-center val">
            {{ v.key === "totalTradedAmount" ? "￥" : "" }}{{ v.value || 0 }}
          </div>
        </div>
      </div>
    </div>
    <div class="bg mb10">
      <div class="mb10 flex flex-between item-center">
        <div class="title">
          导购业绩排行
        </div>
        <div>
          <el-input
            clearable
            style="width:300px"
            v-model.trim="searchCondition.username"
            placeholder="请输入导购账号"
            size="small"
            class="ipt mr10"
          >
          </el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <!-- <el-button type="success" size="small" @click="output"
            >导出</el-button
          > -->
        </div>
      </div>
      <div class="table">
        <el-table
          stripe
          border
          ref="table"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
          @sort-change="sortChange"
        >
          <el-table-column
            type="index"
            label="排名"
            header-align="center"
            align="center"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="username"
            label="导购"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="departName"
            label="所属机构"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="tradedAmount"
            label="成交金额"
            sortable
          >
            <template slot-scope="scope">
              <div class="primary">￥{{ scope.row.tradedAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="tradedOrderNum"
            label="总成交次数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sharePosterTradedNum"
            label="海报分享成交次数"
            sortable
          >
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="smgTradedNum"
            label="代客下单成交次数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sharePosterNum"
            label="海报分享次数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="smgShareNum"
            label="代客下单分享次数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="browseCustomerNum"
            label="浏览客户数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="showGoodsNum"
            label="展示商品数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="callPhoneNum"
            label="电话联系次数"
            sortable
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <div class="bg mb10">
      <div class="mb10 flex flex-between item-center">
        <div class="title">
          商品成交排行
        </div>
        <div>
          <el-input
            clearable
            style="width:300px"
            v-model.trim="searchCondition.wxshopSpuName"
            placeholder="请输入商品名称"
            size="small"
            class="ipt mr10"
          >
          </el-input>
          <el-button type="primary" size="small" @click="searchTwo"
            >查询</el-button
          >
          <!-- <el-button type="success" size="small" @click="output"
            >导出</el-button
          > -->
        </div>
      </div>
      <div class="table">
        <el-table
          stripe
          border
          ref="table"
          :data="listTwo"
          style="width: 100%"
          id="table"
          size="small"
          @sort-change="sortChangeTwo"
        >
          <el-table-column
            type="index"
            label="排名"
            header-align="center"
            align="center"
            :index="index => index + (currentPageTwo - 1) * pageSizeTwo + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="tradedAmount"
            label="成交总金额"
            sortable
          >
            <template slot-scope="scope">
              <div class="primary">￥{{ scope.row.tradedAmount }}</div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="browseNum"
            label="被浏览次数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="smgTradedNum"
            label="代客下单成交次数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sharePosterTradedNum"
            label="海报分享成交次数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sharePosterNum"
            label="海报分享次数"
            sortable
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="smgTradedNum"
            label="代客下单分享次数"
            sortable
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalTwo"
          @current-change="pagingTwo"
          @size-change="handleSizeChangeTwo"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPageTwo"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      seleteAppList: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
          // {
          //   text: "最近三个月",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit("pick", [start, end]);
          //   }
          // }
        ]
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      listTwo: [],
      totalTwo: 0,
      currentPageTwo: 1,
      pageSizeTwo: 10,
      searchCondition: {},
      tabList: [
        {
          icon: "",
          title: "打开客户线索次数(次)",
          tip: "",
          value: "",
          key: "totalCustomerClueNum"
        },
        {
          icon: "",
          title: "展示客户数(人)",
          tip: "",
          value: "",
          key: "totalBrowseCustomerNum"
        },
        {
          icon: "",
          title: "电话联系次数(次)",
          tip: "",
          value: "",
          key: "totalCallPhoneNum"
        },
        {
          icon: "",
          title: "成交数(次)",
          tip: "",
          value: "",
          key: "totalTradedOrderNum"
        },
        {
          icon: "",
          title: "成交金额(元)",
          tip: "",
          value: "",
          key: "totalTradedAmount"
        },
        {
          icon: "",
          title: "展示商品数(个)",
          tip: "",
          value: "",
          key: "totalShowGoodsNum"
        },
        {
          icon: "",
          title: "代客下单分享数(次)",
          tip: "",
          value: "",
          key: "totalSmgShareNum"
        },
        {
          icon: "",
          title: "海报分享数(次)",
          tip: "",
          value: "",
          key: "totalSharePosterNum"
        }
      ],
      sort: {}
    };
  },
  created() {},
  mounted() {
    this.getSeleteWechat();
  },
  methods: {
    // storeCodeChange() {
    //   this.queryAll();
    // },
    queryAll() {
      if (!this.searchCondition.storeCode || !this.searchCondition.applyDate) {
        return;
      }
      this.queryCustomerClueStatisticsData();
      this.queryList();
      this.queryListTwo();
    },
    async getSeleteWechat() {
      const { result } = await this.$store.dispatch("queryWechatSelete");
      this.seleteAppList = result;
    },

    async queryCustomerClueStatisticsData() {
      const params = {
        orderByValue: this.sort.order,
        orderByType: this.sort.prop,
        queryStartDate:
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "",
        queryEndDate:
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : ""
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryCustomerClueStatisticsData",
        params
      );
      this.tabList.forEach(v => {
        v.value = result[v.key];
        if (v.key == "totalTradedAmount") {
          v.value += ".00"
        }
      });
      console.log('tablist')
      console.log(this.tabList)
    },
    sortChangeTwo(sort) {
      this.pageNoTwo = 1;
      this.sort = sort;
      this.queryListTwo();
    },
    sortChange(sort) {
      this.pageNo = 1;
      this.sort = sort;
      this.queryList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        orderByValue: this.sort.order,
        orderByType: this.sort.prop,
        queryStartDate:
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "",
        queryEndDate:
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : ""
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryStoreCustomerClueStatisticsDateList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        console.log(total)
        console.log(records)
        records.forEach((el,idx,arr)=>{
          arr[idx].tradedAmount += ".00"
        })
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      if (!this.searchCondition.storeCode || !this.searchCondition.applyDate) {
        return;
      }
      this.currentPage = 1;
      this.queryList();
    },
    searchTwo() {
      if (!this.searchCondition.storeCode || !this.searchCondition.applyDate) {
        return;
      }
      this.currentPageTow = 1;
      this.queryListTwo();
    },
    async queryListTwo() {
      const params = {
        pageSize: this.pageSizeTwo,
        pageNo: this.currentPageTwo,
        orderByValue: this.sort.order,
        orderByType: this.sort.prop,
        queryStartDate:
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "",
        queryEndDate:
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : ""
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryStoreSpuClueStatisticsDateList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        records.forEach((el,idx,arr)=>{
          arr[idx].tradedAmount += ".00"
        })
        this.listTwo = records;
        this.totalTwo = total;
        
      }
    },
    pagingTwo(page) {
      this.currentPageTwo = page;
      this.queryListTwo();
    },
    handleSizeChangeTwo(size) {
      this.currentPageTwo = 1;
      this.pageSizeTwo = size;
      this.queryListTwo();
    },
    searchTwo() {
      this.currentPageTwo = 1;
      this.queryListTwo();
    }
  }
};
</script>

<style scoped lang="scss">
.bg {
  padding: 10px 20px;
  background: #fff;
}
.title {
  font-size: 16px;
  &::before {
    display: inline-block;
    margin-right: 2px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.name {
  color: #222222;
  font-size: 14px;
}
.val {
  font-weight: 600;
  color: #222222;
  font-size: 24px;
}
.box {
  padding: 10px 0;
  border: 1px solid #eee;
  margin-right: 10px;
  border-spacing: 0;
  border-collapse: collapse;
  &.bor-left {
    // border-left: 1px solid #eee;
  }
}
</style>
